export { default as component } from "../../../../src/routes/(registration)/auth/password-reset/+page.svelte";